import { EventTicketCustomFieldEntity } from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.models'
import { ImagesEntity } from 'libs/gb-front/shared/models/shared.models'
import {
  BaseEventTicketPackageEntity,
  BaseEventTicketPackageImagesEntity,
  BaseSlimEventTicketPackageEntity,
} from 'libs/shared/models/event-tickets/event-ticket-packages.models'

/**
 * Interface for the 'EventTicketPackages' data
 */
export interface EventTicketPackageEntity extends BaseEventTicketPackageEntity {
  images: EventTicketPackageImagesEntity[]
  notListLoaded?: boolean
}

export interface SlimEventTicketPackageEntity extends BaseSlimEventTicketPackageEntity {}

export interface EventTicketPackageImagesEntity extends BaseEventTicketPackageImagesEntity, ImagesEntity {}

export interface EventTicketPackagesResponse {
  count: number
  next: string | null
  previous: string | null
  results: EventTicketPackageEntity[]
  order_hash: string
}
